import { formatDate } from "@/lib/date-formatting";

/**
 * Format metric value based on data type
 *
 * Handles currency, float, date, and integer formatting with appropriate
 * locale-specific display.
 */
export function formatMetricValue(
  value: number | string,
  type: string,
): string {
  switch (type) {
    case "currency":
      return (value as number).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      });
    case "float":
      return (value as number).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
    case "date":
      return formatDate(value as string);
    default:
      return (value as number).toLocaleString("en-US");
  }
}
